var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.933 0.094102C12.0665 0.172113 12.1698 0.293452 12.226 0.438297C12.2822 0.583141 12.288 0.742929 12.2426 0.891557L9.78673 8.9376H14.3179C14.4511 8.93754 14.5814 8.97681 14.6926 9.05055C14.8039 9.12429 14.8914 9.22927 14.9441 9.35254C14.9969 9.47581 15.0128 9.61196 14.9897 9.7442C14.9666 9.87644 14.9056 9.99896 14.8143 10.0967L3.90558 21.7835C3.80003 21.8967 3.65958 21.9705 3.50711 21.9928C3.35464 22.0152 3.19915 21.9849 3.06598 21.9067C2.93282 21.8286 2.82982 21.7073 2.7738 21.5625C2.71777 21.4178 2.712 21.2582 2.75744 21.1098L5.21326 13.0624H0.682065C0.548904 13.0624 0.418642 13.0232 0.30736 12.9494C0.196077 12.8757 0.108646 12.7707 0.0558587 12.6474C0.00307159 12.5242 -0.0127604 12.388 0.0103171 12.2558C0.0333946 12.1235 0.0943711 12.001 0.18572 11.9033L11.0944 0.21647C11.1998 0.10345 11.3401 0.0297125 11.4923 0.00724624C11.6446 -0.0152201 11.7999 0.0149064 11.933 0.0927271V0.094102Z",
    fill: "#F4FDFF",
    fillOpacity: 0.87451
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.813a8ca93d1933cb59697ab056b48241.svg";
export { ForwardRef as ReactComponent };